import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "flex"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "no-bullet tabs-container disable-select text-xs pb-2 pl-2" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "text-right flex-1 whitespace-nowrap text-xs px-2"
}
const _hoisted_8 = ["for"]
const _hoisted_9 = ["id", "name", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_MonacoReadonly = _resolveComponent("MonacoReadonly")!

  return (_openBlock(), _createElementBlock("div", {
    class: "Panel CodePreview full_height_container grid-y overflow-hidden",
    onPointermove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.on_pointer_move && _ctx.on_pointer_move(...args)))
  }, [
    (_ctx.displayedName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.displayedName), 1 /* TEXT */))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_EmptyState, {
            title: "No GL or JS node selected",
            subtitle: "Select any GLSL or JS node (or its parent node) to display the\n\t\t\t\tgenerated code"
          })
        ])),
    (_ctx.displayedName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shaderNames, (_, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  onClick: ($event: any) => (_ctx.setCurrentShaderIndex(i)),
                  class: _normalizeClass([[_ctx.tabClassObjects[i], _ctx.tabActiveStates[i] ? 'opacity-100' : 'opacity-70'], "px-4 py-1 shader-tab border-b-2 border-text-white text-white hover:border-text-white hover:text-white"])
                }, _toDisplayString(_ctx.shaderNames[i]), 11 /* TEXT, CLASS, PROPS */, _hoisted_6))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]),
          (_ctx.displayExpandToggle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("label", {
                  for: _ctx.expandCheckboxId,
                  class: "ml-2 text-text cursor-pointer disable-select inline"
                }, " Expand Shader ", 8 /* PROPS */, _hoisted_8),
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "h-4 w-4 text-emerald-600 border-slate-800 rounded cursor-pointer focus:outline-none bg-black ml-2",
                  id: _ctx.expandCheckboxId,
                  name: _ctx.expandCheckboxId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expandShaderRequested) = $event)),
                  checked: _ctx.expandShaderRequested
                }, null, 8 /* PROPS */, _hoisted_9), [
                  [_vModelCheckbox, _ctx.expandShaderRequested]
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.editorDisplayed && _ctx.displayedCode)
      ? (_openBlock(), _createBlock(_component_MonacoReadonly, {
          key: 3,
          content: _ctx.displayedCode,
          highlightedLines: _ctx.highlightedLines,
          language: _ctx.monacoLanguage,
          uniqueId: _ctx.editorUniqueId,
          onToggleFullScreen: _ctx.toggleFullScreen
        }, null, 8 /* PROPS */, ["content", "highlightedLines", "language", "uniqueId", "onToggleFullScreen"]))
      : _createCommentVNode("v-if", true)
  ], 32 /* HYDRATE_EVENTS */))
}